export default __webpack_public_path__ + "img/cc025ff92ee0da5bfdd0916535981439.png";